<template>
  <div id="login">
    <!-- nav Start -->
    <nav
      class="navbar navbar-inverse navbar-fixed-top"
      id="navbar"
      style="margin-bottom: 0px"
    >
      <!--      <div class="nav_top">12345</div>-->
      <div class="container-fluid">
        <div class="navbar-header">
          <a class="navbar-brand" href="#" style="padding: 0px !important">
            <img
              id="white-img"
              src="/img/login/link.png"
              style="
                height: 150px;
                margin-left: -4px;
                width: 150px;
                margin-top: -28.5px;
              "
            />
            <img
              id="blue-img"
              src="/img/login/link.png"
              style="
                height: 150px;
                margin-left: -4px;
                width: 150px;
                margin-top: -38.5px;
              "
            />
          </a>
        </div>
        <div class="collapse navbar-collapse">
          <!-- <div class="register">
              <span>
                  <a href="#register" data-toggle="modal" data-target="#RegisterModal" style="font-size:13px;cursor:pointer;font-family:'华文宋体';font-weight:10px;margin-right: 15px;">注册</a>
              </span>
          </div>
          <div class="chatMe_line_about" style="width:1px;height:20px;line-height:50px;border-left:1px white solid;margin-top: 40px;margin-right: 15px;float: right;">
          </div>-->
          <div class="chatMe">
            <span>
              <a
                href="#contact"
                data-toggle="modal"
                data-target=".contactUs"
                style="cursor: pointer; font-family: '华文宋体'"
                id="contactusbtn"
                v-on:click="bgToBlur"
                >联系我们</a
              >
            </span>
          </div>
          <div
            class="chatMe_line_about"
            style="
              width: 1px;
              height: 20px;
              line-height: 50px;
              border-left: 1px white solid;
              margin-top: 40px;
              margin-right: 15px;
              float: right;
            "
          ></div>
          <div class="about">
            <span>
              <a
                @click="modal11 = true"
                v-on:click="navToDisplay"
                id="aboutusbtn"
                style="
                  cursor: pointer;
                  font-family: '华文宋体';
                  margin-right: 15px;
                "
                >关于我们</a
              >
            </span>
          </div>
        </div>
      </div>
    </nav>
    <!-- nav End -->
    <div
      style="width: 100%; height: 100.5%; min-height: 750px"
      class="login_bg"
    >
      <div class="bodyDiv">
        <div class="content">
          <div>
            <div
              class="row content-row"
              style="
                padding: 75px;
                margin: 0 auto;
                height: 840px;
                position: relative;
              "
            >
              <div>
                <!-- slogan -->
                <div style="float: left; margin-top: 45px">
                  <div>
                    <div
                      class="function_title_div"
                      style="width: 470px; margin-top: 90px"
                    >
                      <div style="display: flex">
                        <p
                          class="toptobottom"
                          style="
                            line-height: 60px;
                            top: 30px;
                            font-family: 'Poppins', sans-serif;
                            font-weight: 700;
                            font-style: normal;
                            font-size: 36px;
                            color: #ffffff;
                          "
                        >
                          爱文本 · 会思想的文本
                        </p>
                        <!-- <i class="el-icon-video-play"></i> -->
                        <!-- <i class="el-icon-video-play toptobottom" @click="playVideo" style="font-size:40px;color:white;cursor:pointer;line-height:64px;height:60px;margin-left:20px"></i>
                        <el-dialog
                          title=""
                          :visible.sync="dialogVisible"
                          width="80%"
                          :before-close="handleClose"
                          destroy-on-close
                          >
                          <video  controls style="width:100%;height:100%" controlsList="nodownload" src="https://xueguo.oss-cn-shanghai.aliyuncs.com/talent/video/1/aivideo/68981e6942a841f59cca3eb01a8ac638.mp4"></video>
                        </el-dialog> -->
                      </div>
                      <p
                        class="lefttoright"
                        style="
                          top: 30px;
                          margin-top: 15px;
                          font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
                          font-weight: 700;
                          font-style: normal;
                          font-size: 18px;
                          color: #ffffff;
                        "
                      >
                        分析海量文本，挖掘数据价值
                      </p>
                      <button
                        class="morebtn"
                        custom-icon="el-icon-delete-solid"
                        @click="gosection1()"
                      >
                        <img
                          src="../../static/img/DownLoad.png"
                          width="190px"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Login box -->
                <div class="rightfloatdiv">
                  <div class="login_div">
                    <div class="login-banner">
                      <img src="/img/login/loginbg.png" style="width: 300px" />
                    </div>

                    <form
                      v-if="showAccount"
                      action="#"
                      name="loginForm"
                      method="post"
                      onsubmit="return false;"
                    >
                      <div class="group-control">
                        <div class="group">
                          <Input
                            @on-enter="handleButtonSubmit"
                            v-model="username"
                            placeholder="请输入账号"
                            name="username"
                            type="text"
                            autocomplete
                            clearable
                          />
                          <i class="iconfont icon-user"></i>
                          <div style="height: 40px; float: left; width: 321px">
                            <span
                              id="login_warning"
                              style="color: #40a9ff; line-height: 40px"
                            ></span>
                          </div>
                        </div>
                        <div class="group">
                          <Input
                            @on-enter="handleButtonSubmit"
                            v-model="password"
                            placeholder="请输入密码"
                            type="password"
                            name="password"
                            password
                          />
                          <i class="iconfont icon-passwd"></i>
                        </div>
                        <div class="alogin" @click="TabQiehuanPhone">
                          <i class="iconfont icon-school"></i>
                          <span class="alogin-text">验证码登录</span>
                        </div>
                        <div id="check">
                          <div id="div-input">
                            <Checkbox
                              v-model="checked"
                              class="ivucheckbox"
                              style="font-size: 16px"
                              >记住密码</Checkbox
                            >
                          </div>
                          <div id="div-forget">
                            <a
                              id="forgetpwd"
                              v-on:click="viewforget"
                              href="javascript:;"
                              style="
                                text-decoration: none;
                                cursor: pointer;
                                font-size: 16px;
                                visibility: visible;
                              "
                              >忘记密码?</a
                            >
                          </div>
                        </div>
                      </div>
                    </form>

                    <form
                      v-if="showPhone"
                      id="phoneLogin"
                      action="#"
                      name="loginForm_Phone"
                      method="post"
                      onsubmit="return false;"
                    >
                      <div class="group-control">
                        <div class="group">
                          <Input
                            @on-enter="handleButtonSubmit"
                            v-model="phoneNumber"
                            placeholder="请输入手机号"
                            name="phoneNumber"
                            type="text"
                            autocomplete
                            clearable
                          />
                          <i class="iconfont icon-user"></i>
                          <div style="height: 40px; float: left; width: 321px">
                            <span
                              id="login_warning_phone"
                              style="color: #40a9ff; line-height: 40px"
                            ></span>
                          </div>
                        </div>
                        <div class="group" style="position: relative">
                          <Input
                            @on-enter="handleButtonSubmit"
                            v-model="verificationCode"
                            placeholder="请输入验证码"
                            type="text"
                            name="verificationCode"
                            maxlength="6"
                          />
                          <i class="iconfont icon-passwd"></i>
                          <Button
                            @click="sendVerificationCode"
                            :disabled="countdown > 0 || sending"
                            style="
                              position: absolute;
                              right: 10px;
                              top: 50%;
                              transform: translateY(-50%);
                              min-width: 100px;
                              max-width: 130px;
                            "
                            :loading="sending"
                          >
                            {{
                              countdown > 0
                                ? `${countdown}s后重试`
                                : "获取验证码"
                            }}
                          </Button>
                        </div>
                        <div class="alogin" @click="TabQiehuanAccount">
                          <i class="iconfont icon-school"></i>
                          <span class="alogin-text">密码登录</span>
                        </div>
                      </div>
                    </form>

                    <Button class="btnLogin" v-on:click="handleButtonSubmit"
                      >登 录</Button
                    >
                    <Button class="ReLogin" v-text="" v-on:click="Register"
                      >注 册</Button
                    >
                    <div class="ipdisplay">
                      <span>IP：{{ cip }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Header Bottom -->
      <div id="box">
        <div class="box-content">
          <!--        <div class="left"></div>-->
          <div
            class="middle-1"
            style="border-left: 0.5px solid rgba(255, 255, 255, 0.2)"
          >
            <div class="middle-1-div">
              <img
                class="middle-1-img"
                src="/img/login/middle1.png"
                style="top: 30px"
              />
              <div
                class="text"
                style="
                  position: absolute;
                  margin-left: 100px;
                  color: white;
                  top: 50px;
                "
              >
                <span style="font-size: 16px; font-weight: 700"
                  >海量文本信息</span
                >
              </div>
            </div>
          </div>
          <div class="middle-1">
            <div class="middle-1-div">
              <img
                class="middle-1-img"
                style="left: 0px; top: 29px"
                src="/img/login/middle2.png"
              />
              <div
                class="text"
                style="
                  position: absolute;
                  margin-left: 100px;
                  color: white;
                  top: 50px;
                "
              >
                <span style="font-size: 16px; font-weight: 700"
                  >深度语义解析</span
                >
              </div>
            </div>
          </div>
          <div class="middle-1">
            <div class="middle-1-div">
              <img
                class="middle-1-img"
                style="left: -10px; top: 30px"
                src="/img/login/middle3.png"
              />
              <div
                class="text"
                style="
                  position: absolute;
                  margin-left: 100px;
                  color: white;
                  top: 50px;
                "
              >
                <span style="font-size: 16px; font-weight: 700"
                  >机器学习工具</span
                >
              </div>
            </div>
          </div>
          <div
            class="right"
            style="
              width: 14%;
              height: 120px;
              border-right: 0.5px solid rgba(255, 255, 255, 0.2);
            "
          ></div>
        </div>
      </div>

      <!-- Tip Modal -->
      <div
        class="modal fade"
        id="systemAlterModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="systemAlterModal"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div class="modal-dialog" style="width: 500px; background: transparent">
          <div class="modal-content" style="border: 0px; border-radius: 8px">
            <div
              class="modal-header"
              style="padding: 7px 15px; background: rgb(52, 122, 191)"
            >
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
                style="font-size: 26px; outline: none; color: black"
              >
                &times;
              </button>
              <h4 class="modal-title">
                <span style="color: white; font-size: 16px">提示</span>
              </h4>
            </div>
            <div
              class="modal-body"
              style="background: white; border-radius: 8px; padding-top: 25px"
            >
              <div
                style="
                  height: 80px;
                  margin-left: 20px;
                  padding: 2px 0px;
                  font-size: 15px;
                "
              >
                <img
                  style="display: block; float: left"
                  :src="'/img/index/errorImg.png'"
                />
                <p style="line-height: 25px; margin-left: 40px">
                  <span
                    id="alertMsg"
                    style="margin-left: 20px; font-size: 16px"
                  ></span>
                </p>
              </div>
              <div class="featureWarning_bottom_div">
                <!-- <div style="float:left;margin-left:60px;">
                       <input id="noWarningCheck" style="position:relative;top:2px;width:14px;height:14px;outline:none;" type="checkbox">
                       <label for="noWarningCheck" style="font-weight:500;cursor:pointer;">&nbsp;本次登录不再提醒</label>
                     </div> -->
                <div style="float: right; margin-right: 40px">
                  <button
                    class="continue_button"
                    type="button"
                    data-dismiss="modal"
                  >
                    关闭
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Aboutus Modal -->
      <Modal v-model="modal11" fullscreen footer-hide class="modalaboutus">
        <a v-on:click="navToapper" slot="close"
          ><i class="ivu-icon ivu-icon-ios-close"></i
        ></a>
        <div>
          <section class="block overlay">
            <div class="fixed-bg bg1"></div>
            <div class="container">
              <div class="section-title">
                <h2 class="h-title">爱文本(AItexts)智能文本分析系统</h2>
              </div>
              <div class="services">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="service-col">
                      <h2>01<span>.</span></h2>
                      <h4>我们的愿景</h4>
                      <p>致力于成为领先的智能文本分析应用平台</p>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="smpl-txt">
                      <h4>关于我们</h4>
                      <p>
                        “爱文本（AItexts）智能文本分析系统”是由知名人工智能团队开发，上海经禾信息技术有限公司负责运维和市场推广的新一代智能文本分析产品。爱文本智能文本分析系统专注于为广大科研人员和业界投资人士提供精确、高效和便捷的文本分析工具和服务，致力于帮助客户深度挖掘文本信息，获取包括诸如文本词频、语调情感、文本可读性和文本相似度等文本分析结果，实现科研和投资的智慧化。
                      </p>
                      <p>
                        爱文本智能文本分析系统在文本获取与清洗、文本语义分析、文本信息智能化呈现上具有多年的业务实践和技术积淀，凭借领先的文本数字化和智能化产品，打造服务于科研、投资的多维场景解决方案，为客户创造价值。
                      </p>
                      <p>
                        爱文本智能文本分析系统将继续秉承开放合作、价值创造的原则，积极协同科学研究和投资实务等各领域的合作伙伴，为用户量身打造高价值、高水平的文本分析应用软件产品和解决方案。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row" style="position: relative; top: -170px">
                  <div class="col-lg-6">
                    <div class="service-col">
                      <h2>02<span>.</span></h2>
                      <h4>我们的使命</h4>
                      <p>
                        汇聚海量文本，深度挖掘信息，助力用户实现智慧研究和投资
                      </p>
                    </div>
                  </div>
                  <div class="col">
                    <div class="service-col" style="max-width: 1000px"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div slot="footer"></div>
      </Modal>
      <iframe
        id="MsgBoardIframe"
        name="MsgBoardIframe"
        style="display: none"
      ></iframe>
      <!-- Contactus Modal -->
      <div
        class="modal fade contactUs mirror"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        style="color: initial; font-family: '微软雅黑'; font-size: 14px"
        data-backdrop="static"
        v-on:keyup.esc="clearBgBlur"
      >
        <div class="modal-dialog modal-lg">
          <form
            action="/api/submitAdvice.do"
            target="MsgBoardIframe"
            method="post"
            id="submitAdviceForm"
          >
            <div class="modal-content contact">
              <div class="modal-header">
                <button
                  id="closeContactUsModalBtn"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  v-on:click="clearBgBlur"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3 class="">
                  Contact us | <span style="font-size: 95%">联系我们</span>
                </h3>
                <p class="modal-title"></p>
              </div>
              <div class="modal-body">
                <div class="contacttxt">
                  <!--                  <p style="color:red;">(重要提示：因春节放假，1月26日至2月4日的用户注册，于2月5日统一审核处理，给您带来的不便敬请谅解！祝您春节快乐，万事如意！)</p>-->
                  <p style="padding-bottom: 5px">
                    尊敬的先生/女士，欢迎您关注爱文本（AI
                    texts）智能文本分析系统。
                  </p>
                  <p>
                    您可以在下方文本框中填写任何对于我们产品的问题或需求建议，我们将在<b>一个工作日内</b>回复您；或者您也可以直接联络我们，获得更多信息！
                  </p>
                </div>
                <div>
                  <div class="form-group" id="comment-form-author">
                    <label for="name">称谓</label>
                    <input
                      type="text"
                      style="
                        border: 1px solid rgb(76, 131, 188);
                        padding: 5px 10px 5px 35px;
                      "
                      class="form-control"
                      name="name"
                      placeholder="name"
                    />
                  </div>
                  <div class="form-group" id="comment-form-phone">
                    <label for="phone">电话</label>
                    <input
                      type="text"
                      style="
                        border: 1px solid rgb(76, 131, 188);
                        padding: 5px 10px 5px 35px;
                      "
                      class="form-control"
                      name="phone"
                      placeholder="phone"
                    />
                  </div>
                  <div class="form-group" id="comment-form-school">
                    <label for="school">学校</label>
                    <input
                      type="text"
                      style="
                        border: 1px solid rgb(76, 131, 188);
                        padding: 5px 10px 5px 35px;
                      "
                      class="form-control"
                      name="school"
                      placeholder="school"
                    />
                  </div>
                  <div class="form-group" id="comment-form-email">
                    <label for="email">E-mail</label>
                    <input
                      type="email"
                      style="
                        border: 1px solid rgb(76, 131, 188);
                        padding: 5px 10px 5px 35px;
                      "
                      class="form-control"
                      name="email"
                      placeholder="e-mail"
                    />
                  </div>
                  <div class="form-group">
                    <label for="message">留言</label>
                    <textarea
                      class="form-control"
                      rows="3"
                      name="message"
                      placeholder="please enter your message"
                    ></textarea>
                  </div>
                  <div>
                    <button
                      type="submit"
                      id="contactbtn"
                      class="btn btn-primary"
                    >
                      Submit | 提交
                    </button>
                  </div>
                </div>
                <hr style="width: 100%" />
                <div class="contactinf">
                  <h4 style="color: black">Contact information | 联系信息</h4>
                  <p>用户经理：刘经斌</p>
                  <p>售前咨询、需求对接</p>
                  <p>电话：13391311631</p>
                  <p>邮箱：dataservice@aitexts.com</p>
                  <img
                    src="/img/login/wechat_QRCode_left.png"
                    class="img_class"
                    style="width: 100px; height: 100px"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- login End -->
    <!-- Processing Flow -->
    <div class="processing-flow">
      <div class="pf-content container">
        <h2 class="c-title">文本大数据处理流程</h2>
        <p class="c-texts">
          汇聚海量文本，深度挖掘信息，助力用户实现智慧研究和投资
        </p>
        <img src="/img/login/pic-pf.png" alt="" />
      </div>
    </div>
    <!-- Expert Team -->
    <div class="expert-team">
      <div class="et-content container">
        <div class="et-left col-lg-6">
          <h2 class="et-title c-title">我们的专家团队</h2>
          <p class="et-texts">
            爱文本智能文本分析系统专注于为广大科研人员和业界投资人士提供精确、高效和便利的文本分析工具和服务，合作成员包括财经、计算机、大数据领域专家，知名高校教授学者。
          </p>
          <ul>
            <li>
              <img
                src="/img/login/bullets-8px.png"
                alt=""
              />财经专家：需求分析、产品设计、字段校对
            </li>
            <li>
              <img
                src="/img/login/bullets-8px.png"
                alt=""
              />计算机专家：提供大数据解决方案
            </li>
          </ul>
        </div>
        <div class="et-right col-lg-6">
          <img src="/img/login/pic-et.png" alt="" />
        </div>
      </div>
    </div>
    <!-- Text Solution -->
    <div class="text-solution">
      <div class="ts-wrapper">
        <div class="ts-content container">
          <h2 class="c-title">专业文本解决方案</h2>
          <p class="c-texts">
            汇聚海量文本，深度挖掘信息，助力用户实现智慧研究和投资
          </p>
        </div>
      </div>
      <!-- Tab -->
      <div class="ts-tab">
        <div class="tab-content container">
          <div class="col-lg-3 tabpane">
            <span class="pane-1 pane">海量文本</span>
          </div>
          <div class="col-lg-3 tabpane">
            <span class="pane-2 pane">前沿算法</span>
          </div>
          <div class="col-lg-3 tabpane">
            <span class="pane-3 pane">快速计算</span>
          </div>
          <div class="col-lg-3 tabpane">
            <span class="pane-4 pane">可视化工具</span>
          </div>
        </div>
      </div>
      <!-- Massive Text Data -->
      <div class="massive-textdata tstab1 tstabs">
        <div class="mt-content container">
          <div class="col-lg-6 mt-left">
            <div id="holder"></div>
          </div>
          <div class="col-lg-6 mt-right">
            <p class="title-en">Massive amounts of text</p>
            <h3 class="title-zh">海量文本</h3>
            <p class="tx-short">海量财经领域文本，覆盖各个来源</p>
            <ul>
              <li>
                <img src="/img/login/bullets-6px.png" alt="" />PB级巨量原始文本
              </li>
              <li>
                <img src="/img/login/bullets-6px.png" alt="" />上百种文本类型
              </li>
              <li>
                <img
                  src="/img/login/bullets-6px.png"
                  alt=""
                />千亿条文本挖掘信息
              </li>
            </ul>
            <div class="tx-btngroup">
              <!--              <button class="primary-btn">立即体验</button>-->
              <button class="default-btn" v-on:click="gosection1">
                立即体验
              </button>
              <!-- <button class="default-btn" v-on:click="Register">立即体验</button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- arrow-box-1-->
      <div class="arrow-box">
        <div class="arrow-wrapper">
          <svg
            class="arrow-down"
            width="36"
            height="16"
            viewBox="0 0 42 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M40 1H2L21 15L40 1Z"
              fill="#ffffff"
              stroke="#ffffff"
              class="path1"
            />
          </svg>
        </div>
      </div>
      <!-- Frontier Algorithm -->
      <div class="frontier-algorithm tstab2 tstabs">
        <div class="rg_top"></div>
        <div class="fa-content container">
          <div class="col-lg-6 fa-left">
            <p class="title-en">Frontier algorithm</p>
            <h3 class="title-zh">前沿算法</h3>
            <p class="tx-short">前沿的自然语言处理、深度学习算法</p>
            <div class="tx-btngroup">
              <!--              <button class="primary-btn">立即体验</button>-->
              <!-- <button class="ghost-btn" v-on:click="Register">立即体验</button> -->
              <button class="ghost-btn" v-on:click="gosection1">
                立即体验
              </button>
            </div>
          </div>
          <div class="col-lg-6 fa-right">
            <img src="/img/login/pic-fa.png" alt="" />
          </div>
        </div>
        <div class="rg_top2"></div>
      </div>
      <!-- arrow-box-2-->
      <div class="arrow-box">
        <div class="arrow-wrapper">
          <svg
            class="arrow-down"
            width="42"
            height="16"
            viewBox="0 0 42 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M40 1H2L21 15L40 1Z"
              fill="#16192a"
              stroke="#16192a"
              class="path2"
            />
          </svg>
        </div>
      </div>
      <!-- Rapid Calculation -->
      <div class="rapid-calculation tstab3 tstabs">
        <div class="rc-content container">
          <img class="bg-rcl" src="/img/login/bg-rcl.png" alt="" />
          <img class="bg-rcr" src="/img/login/bg-rcr.png" alt="" />
          <p class="title-en">Rapid calculation</p>
          <h3 class="title-zh">快速计算</h3>
          <p class="tx-short">采用分布式架构、AI芯片提升计算速度</p>
          <ul>
            <li>
              <img src="/img/login/pic-rc1.png" alt="" />
              <div class="li-r">
                <p class="li-r-title">分布式计算</p>
                <p class="li-r-info">
                  采用Hadoop、TensorFlow等分布式平台提升计算速度
                </p>
              </div>
            </li>
            <li>
              <img src="/img/login/pic-rc2.png" alt="" />
              <div class="li-r">
                <p class="li-r-title">AI芯片</p>
                <p class="li-r-info">
                  搭建了专门用于处理人工智能应用中的大量计算任务的模块
                </p>
              </div>
            </li>
          </ul>
          <div class="tx-btngroup">
            <!--            <button class="primary-btn">立即体验</button>-->
            <!-- <button class="default-btn" v-on:click="Register">立即体验</button> -->
            <button class="default-btn" v-on:click="gosection1">
              立即体验
            </button>
          </div>
        </div>
      </div>
      <!-- arrow-box-3-->
      <div class="arrow-box">
        <div class="arrow-wrapper">
          <svg
            class="arrow-down"
            width="42"
            height="16"
            viewBox="0 0 42 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M40 1H2L21 15L40 1Z"
              fill="#e7f1f6"
              stroke="#e7f1f6"
              class="path3"
            />
          </svg>
        </div>
      </div>
      <!-- Search Engine -->
      <div class="search-engine tstab4 tstabs">
        <div class="se-content container">
          <div class="col-lg-5 se-left">
            <p class="title-en">Visualization tools</p>
            <h3 class="title-zh">可视化工具</h3>
            <p class="tx-short">支持可视化文本分析、机器学习、自然语言处理</p>
            <div class="tx-btngroup">
              <!--              <button class="primary-btn">立即体验</button>-->
              <!-- <button class="default-btn"  v-on:click="Register02">立即下载</button> -->
              <button class="morebtn1" v-on:click="gosection1">立即下载</button>
            </div>
          </div>
          <div class="col-lg-7 se-right">
            <img src="/img/new/T2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- Footer Top -->
    <div class="footer-top">
      <div class="ft-content container">
        <h2>开始体验 | AITEXTS · 爱文本智能文本分析系统</h2>
        <p>爱文本，让财经领域大数据研究变得具有普适性</p>
        <button class="primary-btn" @click="gosection1">立即使用</button>
        <!-- <button class="primary-btn" @click="gotop()">立即使用</button> -->
      </div>
    </div>
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="rg_bottom"></div>
      <div class="fb-content container">
        <div class="fb-info col-lg-3">
          <img
            class="fb-logo"
            src="/img/login/AItexts-white.png"
            alt="AI texts"
          />
          <div class="fb-copyright">
            <p style="font-size: 16px">
              ©2014-2025 by Shanghai Jing He All Rights Reserved
            </p>
            <p>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                style="color: white"
                >沪ICP备15037428号-16</a
              >
            </p>
          </div>
        </div>
        <div class="fb-support col-lg-3">
          <div class="fb-title">支持</div>
          <ul class="fb-ul">
            <li class="fb-li" @click="modal11 = true" style="cursor: pointer">
              关于
            </li>
            <li class="fb-li">
              <a href="#contact" data-toggle="modal" data-target=".contactUs"
                >联系我们</a
              >
            </li>
          </ul>
        </div>
        <div class="fb-product col-lg-3">
          <div class="fb-title">产品</div>
          <ul class="fb-ul">
            <li class="fb-li">
              <a href="https://www.cnrds.com/Home/Index#/" target="_blank">
                <span class="li-en">CNRDS</span>
                <span class="li-zh">中国研究服务平台</span>
              </a>
            </li>
            <!-- <li class="fb-li">
              <a href="https://www.gfedata.com/Home/Index#/" target="_blank">
                <span class="li-en">GFE</span>
                <span class="li-zh">全球财经数据库</span>
              </a>
            </li> -->
          </ul>
        </div>
        <div class="fb-contactus col-lg-3">
          <div class="fb-title">联系我们</div>
          <ul class="fb-ul">
            <li class="fb-li">
              <img
                src="/img/login/icon-email.png"
                alt=""
              />dataservice@aitexts.com
            </li>
            <li class="fb-li">
              <img src="/img/login/icon-phone.png" alt="" />+86 021-66181082
            </li>
            <li class="fb-li">
              <img
                src="/img/login/icon-location.png"
                alt=""
              />上海市宝山区逸仙路2816号华滋奔腾大厦
            </li>
          </ul>
        </div>
      </div>
      <img class="fb-mark" src="/img/login/mark.png" alt="" />
      <div class="rg_bottom2"></div>
    </div>
    <Modal
      class-name="vertical-center-modal"
      v-model="activateModal"
      title="信息"
      @on-ok="() => (activateModal = false)"
    >
      <p>{{ activateModalMessage }}</p>
    </Modal>
  </div>
</template>
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
<style scoped>
.morebtn1 {
  position: relative;
  width: 160px;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  padding: 0 20px;
  text-align: center;
  color: #fff;
  /*color: black;*/
  /*background: #2d73b9;*/

  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  border: 1px solid #fff;
  -webkit-transition: all 500ms;
  transition: all 500ms;
  background-color: #3f90f2;
  border: 0;
  box-shadow: 0 0 0 0 rgb(81 107 3.6%);
  margin-top: 32px;
}

.morebtn1:hover {
  animation: pulse 2s infinite;

  background: #2f6ee4;
}

.morebtn1:focus {
  outline: none;
}

/*登录页css*/
.morebtn {
  background: rgba(0, 0, 0, 0);
  /*position: relative;*/
  width: 160px;
  height: 48px;
  line-height: 48px;
  /*font-size: 14px;*/
  /*padding: 0 20px;*/
  /*text-align: center;*/
  color: #fff;

  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  border: 1px solid #fff;
  -webkit-transition: all 500ms;
  transition: all 500ms;
  border: 0;
  box-shadow: 0 0 0 0 rgb(81 107 3.6%);
  margin-top: 32px;
}

/*.morebtn:hover {*/
/*  animation: pulse 2s infinite;*/
/*   background: #3d9bdb;*/
/*}*/

.morebtn:focus {
  outline: none;
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(81, 107, 144, 0.4);
  }
  70% {
    box-shadow: 0 0 0 0.625em rgba(104, 58, 206, 0);
  }
}

.login_bg {
  background: url("/img/login/banner.jpg") #9ac2f8 no-repeat;
  /*background: url("/img/login/bann1.png") no-repeat;*/

  /*background: #3d85fd url(/img/login/landing-bg.png) no-repeat;*/
  background-size: cover;
  position: relative;
  background-blend-mode: multiply;
  /*CSS3颜色叠加background-blend-mode:multiply;(正片叠底)*/
}

.rightfloatdiv {
  float: right;
  margin-top: 70px;
  padding: 25px 39px 60px;
  background-color: rgba(0, 0, 0, 0.2);
  /*background-color: rgba(0, 0, 0, -0.9);*/
  box-shadow: 0 0 1em rgba(0, 0, 0, 0.2);
  position: relative;
}

.ipdisplay {
  width: calc(100% - 2px);
  width: 100%;
  height: 36px;
  line-height: 36px;
  position: absolute;
  bottom: 1px;
  left: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  /*background-color: rgba(0, 0, 0, -0.9);*/
  /*color: black;*/

  /*text-align: center;*/
  text-align: right;
  /*padding-left: 39px;*/
  padding-right: 39px;
  color: #ffffff75;
  font-size: 12px;
  letter-spacing: 0.4px;
  text-shadow: 1.5px 1.5px 2px rgba(0, 0, 0, 0.5);
}

.login-banner {
  margin: 0 auto;
}

.login_div {
  width: 320px;
  /*border:1px solid #ededed;*/
  /*border-radius: 4px;*/
  margin: 0px auto;
}

.login_div form {
  width: 320px;
  margin-top: 15px;
}

.group-control {
  width: 320px;
}

.group {
  margin: 0 auto;
  width: 100%;
  margin-bottom: 32px;
  position: relative;
  color: white;
}

label {
  font-weight: normal !important;
}

.group /deep/ input {
  border: none;
  border-bottom: 1px solid rgba(238, 238, 238, 0.4);
  border-radius: 2px;
  height: 40px;
  line-height: 41px;
  margin: 0px;
  margin-left: 30px;
  padding: 6.5px 0px;
  padding-bottom: 0px;
  margin-top: -5px;
  color: #fff;
  width: calc(100% - 30px);
  font-size: 14px;
  /*padding-left: 36px;*/
  vertical-align: middle;
  letter-spacing: 0.05rem;
  background-color: transparent !important;
  transition: all 0.3s;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.group /deep/ input:-internal-autofill-previewed,
.group /deep/ input:-internal-autofill-selected {
  box-shadow: 0 0 0px 1000px #072251 inset !important;
  -webkit-text-fill-color: #ffffff !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

.group /deep/ input::placeholder {
  color: rgba(255, 255, 255, 0.45);
  font-size: 13px;
}

.group /deep/ input:focus {
  border: none;
  border-bottom: 1px solid #40a9ff;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: none;
}

.group /deep/ input:hover {
  border-color: #40a9ff;
  border-right-width: 1px !important;
}

span.group-title {
  color: rgba(255, 255, 255, 0.5);
  /*color: black;*/

  /* opacity: 0; */
  margin-bottom: 5px;
  display: block;
}

.icon-user,
.icon-passwd {
  position: absolute;
  left: 0px;
  /*top: 24px;*/
  line-height: 40px;
  font-size: 18px;
  color: #ffffff75;
}

.ivucheckbox {
  color: rgba(255, 255, 255, 0.9);
  /*color: black;*/

  line-height: 15px;
  font-size: 12px;
  letter-spacing: 0.05rem;
}

.ivucheckbox /deep/ .ivu-checkbox:hover .ivu-checkbox-inner {
  border-color: #40a9ff;
}

.ivucheckbox /deep/ .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #40a9ff;
}

.ivucheckbox /deep/ .ivu-checkbox-inner {
  border: 1px solid rgba(238, 238, 238, 0.4);
  background-color: transparent;
  margin-right: 8px;
  margin-left: 2px;
}

.ivucheckbox /deep/ .ivu-checkbox-checked .ivu-checkbox-inner:after {
  border: 2px solid #40a9ff;
  border-top: 0;
  border-left: 0;
}

.ReLogin {
  float: right;
  height: 40px;
  width: 40%;
  padding-left: 0px;
  color: #fff;
  font-size: 16px;
  background: #2d73b9;
  border: 1px solid #2d73b9;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  padding: 6.4px 15px;
  border-radius: 2px;
  transition: all 0.3s;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.ReLogin:hover {
  color: #fff;
  background: #5c97f9;
  border-color: #5c97f9;
}

.ReLogin:focus {
  color: #fff;
  background: #40a9ff;
  border-color: #40a9ff;
  outline: none;
}

.btnLogin {
  height: 40px;
  width: 50%;
  padding-left: 0px;
  color: #fff;
  font-size: 16px;
  background: #2d73b9;
  border: 1px solid #2d73b9;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  padding: 6.4px 15px;
  border-radius: 2px;
  transition: all 0.3s;
  transition-property: all;
  transition-duration: 0.3s;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.btnLogin:hover {
  color: #fff;
  background: #5c97f9;
  border-color: #5c97f9;
}

.btnLogin:focus {
  color: #fff;
  background: #40a9ff;
  border-color: #40a9ff;
  outline: none;
}

.content form #check {
  margin-bottom: 27px;
}

.alogin {
  line-height: 40px;
  color: #ffd700;
  cursor: pointer;
  font-weight: bold;
  font-size: 17px;
}

.alogin-text {
  margin-left: 4px;
}

.alogin:hover .alogin-text {
  text-decoration: underline;
}

.alogin:hover {
  color: #ffd700;
}

.alogin:focus {
  color: #096dd9;
}

/*登录页css结束*/
#login {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
}

.center form .text {
  width: 198px;
  padding: 0 3px;
  height: 26px;
  border: 0;
  margin: 0 5px 0 2px;
  line-height: 26px;
}

.center form .btnLogin {
  border: 0;
  margin-left: 3px;
  width: 100px;
  height: 28px;
  padding: 0;
  font-size: 0;
  cursor: pointer;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  text-indent: -9999px;
}

.center form .text,
.center form .btnLogin {
  background: transparent;
  float: left;
  _display: inline;
}

.center form a {
  display: block;
  margin-top: 20px;
  height: 30px;
  width: 420px;
}

.center span {
  float: left;
  margin-top: -1px;
  _display: inline;
  margin: 2px 0 0 -1px \9;
  *margin: 5px 0 0 -1px;
  _margin: 5px 0 0 -1px;
}

.content {
  height: 840px;
  width: 100%;
  align-content: center;
  font-size: 12px;
  color: black;
  display: block;
  clear: both;
  line-height: 18px;
  margin: 0 auto;
  top: 26%;
}

.bodyDiv {
  height: calc(100% - 120px);
  width: 100%;
  position: relative;
}

.img_div {
  float: left;
  width: 100%;
  padding-left: 0px;
  margin-top: -13px;
}

.link_img {
  float: left;
}

#login .contactMe {
  margin: 0 auto;
  height: 50px;
  border: 1px solid;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-color: rgba(217, 237, 247, 0.5);
  width: 1250px;
}

.register {
  float: right;
  height: 50px;
  margin-top: 25px;
}

.about {
  float: right;
  height: 50px;
  margin-top: 25px;
}

.chatMe {
  float: right;
  height: 50px;
  margin-top: 25px;
}

#login .contactMe span {
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: #fcfcfc;
}

.bigDiv {
  height: 40px;
  position: relative;
}

.userDiv {
  height: 40px;
  position: absolute;
  line-height: 40px;
  left: 50%;
  margin-left: -110px;
}

#div-forget {
  float: right;
  height: 40px;
  line-height: 40px;
}

#div-input {
  float: left;
  height: 40px;
  line-height: 40px;
}

#forgetpwd {
  margin-bottom: 5px !important;
  float: right;
  color: #fff;
}

.footer_div {
  position: absolute;
  bottom: 15px;
  width: 100%;
  text-align: center;
}

.footer_div div {
  color: white;
  text-align: center;
  width: 100%;
  font-size: 14px;
}

.img_div img {
  width: 55%;
  float: right;
  margin-right: 300px;
}

.c_rightDiv,
.c_leftDiv {
  width: 50%;
  float: left;
}

.modal-backdrop {
  background-color: rgba(255, 255, 255, 0.1);
}

.mirror .modal-footer {
  border-top: 0px solid #e5e5e5;
  padding: 0px;
  padding-right: 15px;
  padding-bottom: 10px;
}

/*.mirror .modal-header {*/
/*    border-bottom: 1px solid #e5e5e5;*/
/*    background: #0a2b69;*/
/*}*/

.mirror .btn:hover {
  margin: 0;
  background-color: #d9edf7 !important;
  color: #000 !important;
}

.contactMe a {
  color: white;
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.select_model_div button {
  border: 1px solid rgb(103, 184, 241) !important;
  background-color: transparent;
}

.startDateDiv button {
  background-color: white;
}

.endDateDiv button {
  background-color: white;
}

.select_model_div button:hover {
  background-color: rgba(183, 218, 239, 0.63);
}

#oneSelect_model .dropdown-menu.inner li:hover {
  background-color: rgba(183, 218, 239, 0.63);
}

.dropdown-menu.open {
  position: relative;
}

.contactMe a:hover {
  color: #fff;
}

.twoImg_div {
  padding: 0;
}

.function_title_div {
  line-height: 40px;
  font-weight: 700;
}

.wenben_title_div {
  line-height: 40px;
  font-weight: 700;
}

.function_content_div {
  width: 386px;
  margin: 0 auto;
  text-align: center;
  margin-top: 30px;
}

.bodyDiv_content_div {
  width: 362px;
  margin: 0 auto;
  margin-top: 30px;
  line-height: 20px;
}

.active {
  line-height: 35px;
  font-weight: 700;
  background-color: rgba(215, 215, 215, 1);
  height: 60px;
}

.wenbenleixing_div {
  margin: 0px auto;
  width: 1440px;
  background-color: white;
  position: relative;
  margin-bottom: 20px;
  margin-top: 15px;
  /* border-top: 1px solid #ccc; */
}

.wenbenleixing_menu_div {
  /* width: 280px; */
  float: left;
  position: relative;
  margin-left: 40px;
}

.wenbenleixing_menu_body_div {
  width: 200px;
  height: 100%;
  margin: 0 auto;
}

.wenbenleixing_navigation_div {
  height: 100px;
  width: 200px;
  /* margin-top: 29px; */
  position: relative;
}

.wenbenleixing_navigation_blueModel_div {
  width: 130px;
  height: 50px;
  line-height: 40px;
  top: 25px;
  text-align: center;
  color: black;
  position: absolute;
  background-color: rgb(228, 226, 226);
  cursor: pointer;
}

.wenbenleixing_navigation_blueModel_div span {
  position: relative;
  top: 5px;
}

.wenbenleixing_title {
  width: 900px;
  float: right;
  /* margin-top: 30px; */
  text-align: center;
  /* padding-top: 20px; */
  margin-right: 160px;
}

.modal-backdrop {
  opacity: 0 !important;
  filter: alpha(opacity=0) !important;
}

.login-hd {
  text-align: center;
  margin-bottom: 0;
}

ul li {
  list-style: none;
}

.login-hd li {
  display: inline-block;
  width: 200px;
  line-height: 38px;
  text-align: center;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

#box {
  height: 120px;
  margin: 0 auto;
  background: rgba(40, 40, 60, 0.9);
  background-color: hsla(0, 0%, 100%, 0.2);
  bottom: 0;
  z-index: 50;
  padding: 0;
}

.left {
  /*position: absolute;*/
  float: left;
  /*left: 0px;*/
  /*top: 0px;*/
  width: 75px;
  height: 120px;
  border-right: 0.5px solid rgba(255, 255, 255, 0.2);
}

.right {
  position: absolute;
  float: right;
  right: 0px;
  top: 0px;
}

.middle-1 {
  float: left;
  height: 120px;
  border-right: 0.5px solid rgba(255, 255, 255, 0.2);
  width: calc(33%);
}

.middle-2 {
  position: relative;
  float: left;
}

.middle-3 {
  position: absolute;
  float: left;
  left: 60%;
}

.middle-1-div {
  width: 300px;
  height: 120px;
  /*float: left;*/
  position: relative;
  margin: 0 auto;
}

#middle-11-div {
  width: 320px;
  height: 120px;
  /*float: left;*/
  position: relative;
  margin: 0 auto;
}

.middle-1-img {
  position: absolute;
  margin-left: 20px;
  width: 70px;
  height: 70px;
}

#middle-2-div {
  width: 300px;
  height: 120px;
  float: left;
  position: relative;
  margin: 0 auto;
}

.middle-2-img {
  position: absolute;
  left: 50px;
  float: left;
  width: 30px;
  height: 30px;
}

#middle-3-div {
  width: 20%;
  height: 120px;
  float: left;
}

.middle-3-img {
  position: absolute;
  left: 7.5%;
  top: 35px;
  float: left;
  width: 70px;
  height: 70px;
}

.parallax {
  background-attachment: fixed !important;
  -webkit-background-size: cover !important;
  background-size: cover !important;
}

.info-box {
  padding: 100px 0 400px;
  text-align: center;
  margin: -23px 0 63px;
  padding-top: 30px;
}

.info-boxduowei {
  padding: 100px 0 400px;
  background: url(/img/login/duowei2.jpg) no-repeat center center;
  text-align: center;
  margin: -23px 0 63px;
  padding-top: 50px;
}

.info-holder {
  padding: 100px 0 100px;
  text-align: center;
  margin: -23px 0 63px;
  padding-top: 50px;
  /*background: url(/img/login/info-holder.jpg) no-repeat center center;*/
  margin: 0 auto;
  width: 1440px;
  height: auto;
}

.wordcloud {
  background-color: rgb(248, 250, 255);
}

#navbar {
  position: absolute;
  /*background: #04487d;*/
}

/*#navbar .nav_top {*/
/*  height: 20px;*/
/*  background: #0a2b69;*/
/*}*/

.white-navbar {
  background-color: #04487d;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  position: fixed !important;
  height: 64px;
}

.white-navbar .chatMe_line_about {
  border-left: 1px solid #666 !important;
  opacity: 0;
}

.white-navbar .about a,
.white-navbar .chatMe a {
  /*color: #666!important;*/
  font-size: 16px;
  line-height: 0px;
}

.white-navbar .about a:hover,
.white-navbar .chatMe a:hover {
  color: #176de6 !important;
  font-size: 16px;
}

.container-fluid {
  padding: 0px;
  width: 1300px;
  margin: 0 auto;
}

.navbar-inverse {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.navbar-inverse .chatMe > span > a {
  color: #fff;
}

.navbar-inverse .about > span > a {
  color: #fff;
}

.navbar-inverse .register > span > a {
  color: #fff;
}

.white-navbar.navbar-inverse .navbar-nav a {
  color: #000 !important;
}

#comment-form-author::before {
  content: "\F007";
  color: #0a2b69;
  position: absolute;
  font-family: FontAwesome;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

#comment-form-email::before {
  content: "\F0E0";
  color: #0a2b69;
  position: absolute;
  font-family: FontAwesome;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

#comment-form-phone::before {
  content: "\F095";
  color: #0a2b69;
  position: absolute;
  font-family: FontAwesome;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

.toptobottom {
  animation: top-bottom ease 1s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
  animation-fill-mode: forwards;
  /*when the spec is finished*/
  -webkit-animation: top-bottom ease 1s;
  -webkit-animation-iteration-count: 1;
  -webkit-transform-origin: 50% 50%;
  -webkit-animation-fill-mode: forwards;
  /*Chrome 16+, Safari 4+*/
  -moz-animation: top-bottom ease 1s;
  -moz-animation-iteration-count: 1;
  -moz-transform-origin: 50% 50%;
  -moz-animation-fill-mode: forwards;
  /*FF 5+*/
  -o-animation: top-bottom ease 1s;
  -o-animation-iteration-count: 1;
  -o-transform-origin: 50% 50%;
  -o-animation-fill-mode: forwards;
  /*Not implemented yet*/
  -ms-animation: top-bottom ease 1s;
  -ms-animation-iteration-count: 1;
  -ms-transform-origin: 50% 50%;
  -ms-animation-fill-mode: forwards;
  /*IE 10+*/
}

.icon.icon-exclamation-sign {
  position: absolute;
  right: -20px;
  color: #c00;
}

@keyframes top-bottom {
  0% {
    transform: translate(0px, -30px);
    opacity: 0;
  }

  100% {
    transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-moz-keyframes top-bottom {
  0% {
    -moz-transform: translate(0px, -30px);
    opacity: 0;
  }

  100% {
    -moz-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-webkit-keyframes top-bottom {
  0% {
    -webkit-transform: translate(0px, -30px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-o-keyframes top-bottom {
  0% {
    -o-transform: translate(0px, -30px);
    opacity: 0;
  }

  100% {
    -o-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-ms-keyframes top-bottom {
  0% {
    -ms-transform: translate(0px, -30px);
    opacity: 0;
  }

  100% {
    -ms-transform: translate(0px, 0px);
    opacity: 100;
  }
}

.lefttoright {
  animation: left-right ease 1s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
  -webkit-animation: left-right ease 1s;
  -webkit-animation-iteration-count: 1;
  -webkit-transform-origin: 50% 50%;
  -moz-animation: left-right ease 1s;
  -moz-animation-iteration-count: 1;
  -moz-transform-origin: 50% 50%;
  -o-animation: left-right ease 1s;
  -o-animation-iteration-count: 1;
  -o-transform-origin: 50% 50%;
  -ms-animation: left-right ease 1s;
  -ms-animation-iteration-count: 1;
  -ms-transform-origin: 50% 50%;
}

@keyframes left-right {
  0% {
    transform: translate(-63px, 0px);
    opacity: 0;
  }

  100% {
    transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-moz-keyframes left-right {
  0% {
    -moz-transform: translate(-63px, 0px);
    opacity: 0;
  }

  100% {
    -moz-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-webkit-keyframes left-right {
  0% {
    -webkit-transform: translate(-63px, 0px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-o-keyframes left-right {
  0% {
    -o-transform: translate(-63px, 0px);
    opacity: 0;
  }

  100% {
    -o-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@-ms-keyframes left-right {
  0% {
    -ms-transform: translate(-63px, 0px);
    opacity: 0;
  }

  100% {
    -ms-transform: translate(0px, 0px);
    opacity: 100;
  }
}

@keyframes toWhite-left {
  from {
    background: url("/img/login/login-1.png") no-repeat;
  }

  to {
    background: url("/img/login/login-left-button.png") no-repeat;
  }
}

@keyframes toBlack-left {
  from {
    background: url("/img/login/login-left-button.png") no-repeat;
  }

  to {
    background: url("/img/login/login-1.png") no-repeat;
  }
}

@keyframes toWhite-right {
  from {
    background: url("/img/login/login-2.png") no-repeat;
  }

  to {
    background: url("/img/login/login-right-button.png") no-repeat;
  }
}

@keyframes toBlack-right {
  from {
    background: url("/img/login/login-right-button.png") no-repeat;
  }

  to {
    background: url("/img/login/login-2.png") no-repeat;
  }
}

.box-content {
  width: 1440px;
  margin: 0 auto;
}

#section-1 {
  background-image: url(/img/login/team.jpg);
  padding-top: 100px;
  margin-top: -23px;
}

.full-section {
  position: relative;
  z-index: 0;
  margin-bottom: 0px;
  padding: 60px 0;
  background: #333 no-repeat center center;
  color: #fff;
}

#RegisterModal .modal-body .login-register-row.mt30 {
  margin-top: 30px;
}

#RegisterModal .modal-body .login-register-row {
  position: relative;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#RegisterModal .modal-body .login-register-row .row-title {
  height: 36px;
  line-height: 36px;
  display: inline-block;
  text-align: right;
  padding-right: 20px;
  width: 120px;
  color: #333;
}

#RegisterModal .modal-body .login-register-row .row-title.is-required:before {
  content: "*";
  color: #c00;
  margin-right: 4px;
}

#RegisterModal .modal-body .login-register-row .allow-text {
  width: 300px;
  line-height: 36px;
  color: #b7a57a;
}

#RegisterModal .modal-body .login-register-row .allow-text .allow-agree {
  color: #50308d;
}

#RegisterModal .modal-body .login-register-row .allow-text .allow-agree:hover {
  color: #b7a57a;
}

#RegisterModal .modal-body .login-register-row .row-input {
  height: 36px;
  width: 300px;
  border: 1px solid #e2e4f5;
  font-size: 14px;
  padding-left: 10px;
  text-shadow: none;
  outline: none;
}

#RegisterModal .modal-body .login-register-row .row-input.input-code {
  width: 120px;
  margin-right: 10px;
}

#RegisterModal .modal-body .login-register-row .code-message {
  width: 170px;
  border: 1px solid #b7a57a;
  text-align: center;
  color: #b7a57a;
  line-height: 34px;
  background: #fefbf5;
  cursor: pointer;
}

#RegisterModalButton {
  width: 170px;
  background: rgb(18, 139, 237);
  color: #fff;
  line-height: 30px;
  height: 50px;
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  font-family: "宋体 Bold", "宋体 常规";
}

.footertop {
  background-color: #132652;
  padding-bottom: 30px;
  padding-top: 80px;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.3;
}

@media (min-width: 1560px) {
  .container {
    width: 1440px;
  }

  .content-row {
    width: 1440px !important;
  }

  #box {
    width: 100%;
  }

  .white-navbar .container-fluid {
    width: 1440px;
  }
}

@media (min-width: 1420px) {
  @media (max-width: 1560px) {
    .container {
      width: 1440px;
    }

    .content-row {
      width: 1440px !important;
    }
  }
}

@media (min-width: 1200px) {
  @media (max-width: 1420px) {
    .info-holder {
      width: 1140px;
    }

    .container-fluid {
      width: 1140px;
    }

    .middle-1-div {
      width: 372px;
    }
  }
}

@media (min-width: 1220px) {
  @media (max-width: 1420px) {
    .single-widget img {
      left: -15px !important;
    }

    .content-row {
      width: 1030px;
    }

    #box {
      width: 1440px;
    }

    .footertop {
      padding-bottom: 15px;
      padding-top: 35px;
    }

    #login {
      overflow-x: auto;
    }
  }
  .content-row {
    width: 1270px;
  }
}

@media (min-width: 1000px) {
  @media (max-width: 1220px) {
    .chatMe {
      margin-right: 20%;
    }

    .img_div img {
      width: 80%;
      float: left;
      margin-left: 40px;
    }

    .container-fluid {
      width: 1214px;
    }

    #white-img {
      margin-left: 25px !important;
    }

    #blue-img {
      margin-left: 25px !important;
    }

    .function_title_div {
      margin-left: -45px;
    }

    .rightfloatdiv {
      margin-top: 45px;
    }

    .middle-1 {
      width: 340px;
    }

    .middle-1-div {
      width: auto;
    }

    .col-lg-6 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
  }
}

@media (max-width: 1000px) {
  .container {
    width: auto;
  }

  .white-navbar .navbar-collapse {
    position: absolute;
    right: 0px;
  }

  .chatMe {
    margin-right: 70px;
  }

  .img_div img {
    width: 80%;
    float: left;
    margin-left: 40px;
  }

  #footerlogo {
    display: none;
  }

  .footertop {
    padding-bottom: 15px;
    padding-top: 35px;
    padding-left: 15px;
  }

  .container-fluid {
    width: 1024px;
    height: 75px;
  }

  #white-img {
    margin-left: 25px !important;
  }

  #blue-img {
    margin-left: 25px !important;
  }

  .function_title_div {
    margin-left: -45px;
  }

  .rightfloatdiv {
    margin-top: 45px;
  }

  .middle-1 {
    width: 340px;
  }

  .middle-1-div {
    width: auto;
  }

  .info-holder {
    /*width: 940px;*/
    margin: 0px 15px;
  }

  #holder {
    padding: 0px;
  }

  .icon-box {
    padding: 42px 60px;
    height: 250px;
  }

  .section3-box {
    margin-bottom: 0px !important;
    width: calc(50% - 30px);
    float: left;
    margin-right: 30px;
    margin-top: 30px;
  }

  .col-lg-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  .section1-top {
    width: 1024px;
  }

  .section1-row {
    width: 1024px;
  }
}

.single-widget {
  margin-bottom: 30px;
}

.single-widget img {
  width: 230px;
  height: 230px;
  position: relative;
  top: -80px;
  left: 20px;
}

.single-widget h3 {
  color: #ccc;
  border-bottom: 1px solid rgba(233, 233, 233, 0.1);
  margin-bottom: 30px;
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.single-widget .additional-link li {
  color: #ccc;
  font-family: "Open Sans", sans-serif;
  margin-bottom: 20px;
}

.single-widget .additional-link li a {
  display: block;
  color: #ccc;
  position: relative;
  padding-left: 20px;
}

.single-widget .additional-link li span {
  display: block;
  color: #ccc;
  position: relative;
  padding-left: 20px;
}

.single-widget .additional-link li a:hover {
  color: white;
}

.single-widget .additional-link li a::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #ccc;
}

.single-widget .additional-link li span::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #ccc;
}

.single-widget .additional-link li a:hover::before {
  background-color: white;
}

.single-widget .address li {
  color: #ccc;
  margin-bottom: 20px;
}

.single-widget .address li i {
  font-size: 20px;
  margin-right: 12px;
  color: #e0e0e0;
  position: relative;
  top: 2px;
}

.aitexts-footer {
  display: flex;
  align-items: center;
  height: 80px;
  background: #132652;
  justify-content: center;
  font-size: 12px;
  flex: 0 0 auto;
  z-index: 10;
  border-top: 1px solid rgba(233, 233, 233, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
    helvetica neue, Arial, noto sans, sans-serif, apple color emoji,
    segoe ui emoji, segoe ui symbol, noto color emoji;
}

.content-wh {
  /* width: 70%; */
  min-width: 1440px;
}

.aitexts-footer,
.aitexts-footer .footer-el {
  display: flex;
  align-items: center;
}

.aitexts-footer .footer-el .footer-addr {
  flex: 1;
  color: #ccc;
}

.aitexts-footer .footer-el .footer-addr .addr {
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, segoe ui, Roboto,
    helvetica neue, Arial, noto sans, sans-serif, apple color emoji,
    segoe ui emoji, segoe ui symbol, noto color emoji;
}

.aitexts-footer .footer-el .footer-logo img {
  width: 100px;
}

.aitexts-footer .footer-el .footer-code img {
  height: 90px;
}

/* 禁止验证码点击 */

#new_yan {
  pointer-events: none;
}

/* contact modal */
.contact {
  font-size: 16px;
}

.contact .modal-header {
  border-bottom: none;
  padding-bottom: 0px;
}

.contact .modal-body label {
  font-size: 80%;
  font-weight: 400;
  color: #b0b0b0;
}

.contact .modal-body p {
  color: #5a5a5a;
  font-weight: 400;
}

#comment-form-author {
  margin-top: 10px;
}

#contactbtn {
  margin-bottom: 15px;
  text-align: center;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 2px;
}

#contactbtn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

#contactbtn:focus {
  background: #248ffa;
  border-color: #248ffa;
  color: #fff;
  outline: none;
}

.contactinf img {
  float: right;
  position: relative;
  top: -100px;
  right: 4px;
}

.contactinf {
}

.contactinf h4 {
  color: #303030;
  margin: 15px 0px;
  margin-top: 20px;
}

.contactinf p {
  font-size: 78%;
  margin: 0 0 10px;
}

.contact .contacttxt p {
  color: #272727;
  font-size: 14.4px;
}

#comment-form-author::before {
  content: "\F3FC";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
  font-size: 16px;
}

#comment-form-phone::before {
  content: "\F15E";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
  font-size: 16px;
}

#comment-form-email::before {
  content: "\F221";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  font-size: 16px;
  line-height: 90px;
}

#comment-form-school::before {
  content: "\F254";
  color: #4184f3;
  position: absolute;
  font-family: Ionicons;
  padding-left: 8px;
  height: 54px;
  line-height: 90px;
}

/*关于我们模态框*/
.modalaboutus /deep/ .ivu-modal-close {
  z-index: 30000;
  margin-right: 25px;
}

.modalaboutus /deep/ .ivu-icon-ios-close {
  font-size: 45px;
}

.modalaboutus /deep/ .ivu-modal-content {
  z-index: 1031;
}

.modalaboutus /deep/ .ivu-modal-body {
  padding: 0px;
  background-color: #0f0f0e;
}

.modalaboutus /deep/ .ivu-modal-body::-webkit-scrollbar {
  width: 5px;
}

.modalaboutus /deep/ .ivu-modal-body::-webkit-scrollbar-thumb {
  border-radius: 20px;
  /*-webkit-box-shadow: inset 0 0 10 px rgba(0, 0, 0, 0.2);*/
  background: rgba(0, 0, 0, 0.25);
}

.modalaboutus /deep/ .ivu-modal-body::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 2 px rgba(0, 0, 0, 0.2);*/
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}

.modalaboutus /deep/ .container {
  width: 1410px;
  padding: 0 15px;
}

.fixed-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
}

.bg1 {
  background-image: url("/img/login/gai2.png ");
  filter: brightness(0.3);
  background-color: #0f0f0e;
}

.block {
  padding: 170px 0;
}

.section-title {
  position: relative;
  margin-bottom: 60px;
}

.section-title .h-title {
  color: #fff;
  font-size: 68px;
  font-weight: 700;
  line-height: 80px;
  max-width: 500px;
  font-family: "Cinzel", serif;
  animation: fromtopTobottom 0.9s;
  -webkit-animation: fromtopTobottom 0.9s; /* Safari and Chrome */
  -moz-animation: fromtopTobottom 0.9s; /* Firefox */
  -o-animation: fromtopTobottom 0.9s; /* Opera */
  position: relative;
  margin-top: 15px;
}

.overlay {
  position: relative;
  z-index: 9;
}

.overlay:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #262626;
  z-index: -1;
  opacity: 0.85;
}

.services .service-col {
  animation: fromleftToright 0.9s;
  -webkit-animation: fromleftToright 0.9s; /* Safari and Chrome */
  -moz-animation: fromleftToright 0.9s; /* Firefox */
  -o-animation: fromleftToright 0.9s; /* Opera */
  position: relative;
  padding-left: 5px;
}

.services .service-col h2 {
  color: #fff;
  font-size: 56px;
  font-weight: 400;
  font-family: "Cinzel", serif;
  margin-bottom: 4px;
}

.services .service-col h2 span {
  color: #f43930;
}

.services .service-col h4 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 11px;
}

.services .service-col p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  font-weight: 500;
  line-height: 19px;
}

.smpl-txt {
  background-color: rgba(37, 37, 37, 0.7);
  border: 1px solid #6e6e6e;
  padding: 63px 88px 47px;
  margin-top: -225px;
  margin-bottom: 55px;
  animation: fromrightToleft 0.9s;
  -webkit-animation: fromrightToleft 0.9s; /* Safari and Chrome */
  -moz-animation: fromrightToleft 0.9s; /* Firefox */
  -o-animation: fromrightToleft 0.9s; /* Opera */
  position: relative;
}

.smpl-txt h4 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 23px;
}

.smpl-txt p {
  color: rgba(255, 255, 255, 0.4);
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 15px;
}

@keyframes fromtopTobottom {
  0% {
    top: -30px;
  }
  100% {
    top: 0px;
  }
}

@-moz-keyframes fromtopTobottom /* Firefox */ {
  0% {
    top: -30px;
  }
  100% {
    top: 0px;
  }
}

@-webkit-keyframes fromtopTobottom /* Safari and Chrome */ {
  0% {
    top: -30px;
  }
  100% {
    top: 0px;
  }
}

@-o-keyframes fromtopTobottom /* Opera */ {
  0% {
    top: -30px;
  }
  100% {
    top: 0px;
  }
}

@keyframes fromrightToleft {
  0% {
    right: -30px;
  }
  100% {
    right: 0px;
  }
}

@-moz-keyframes fromrightToleft /* Firefox */ {
  0% {
    right: -30px;
  }
  100% {
    right: 0px;
  }
}

@-webkit-keyframes fromrightToleft /* Safari and Chrome */ {
  0% {
    right: -30px;
  }
  100% {
    right: 0px;
  }
}

@-o-keyframes fromrightToleft /* Opera */ {
  0% {
    right: -30px;
  }
  100% {
    right: 0px;
  }
}

@keyframes fromleftToright {
  0% {
    left: -30px;
  }
  100% {
    left: 0px;
  }
}

@-moz-keyframes fromleftToright /* Firefox */ {
  0% {
    left: -30px;
  }
  100% {
    left: 0px;
  }
}

@-webkit-keyframes fromleftToright /* Safari and Chrome */ {
  0% {
    left: -30px;
  }
  100% {
    left: 0px;
  }
}

@-o-keyframes fromleftToright /* Opera */ {
  0% {
    left: -30px;
  }
  100% {
    left: 0px;
  }
}

.navbar-fixed-top,
.navbar-fixed-bottom {
  z-index: 1000;
}

/* public */
.primary-btn {
  background: #2d73b9;
  border: 1px solid #2d73b9;
  border-radius: 4px;
  color: #fff;
  width: 160px;
  height: 50px;
  text-align: center;
  font-size: 18px;
  line-height: 24px;
}

.primary-btn:hover {
  border: 1px solid #3f90f2;
  background: #3f90f2;
}

.c-title {
  font-size: 30px;
  line-height: 41px;
  text-align: center;
  color: #000000;
  padding: 0px;
}

.c-texts {
  margin-top: 12px;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #666666;
}

/* temporary */

/* Expert Team Start */
.expert-team {
  height: 600px;
  /*border-bottom: 1px solid #eee;*/
  background: url(/img/login/bg-et.png);
  background-size: 100% 100%;
}

.et-title {
  text-align: left;
}

.et-left {
  padding-top: 170px;
}

.et-texts {
  margin-top: 33px;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04em;
  text-indent: 2em;
  width: 450px;
  padding: 0px;
}

.et-left ul {
  margin-top: 10px;
}

.et-left li {
  font-size: 16px;
  margin-bottom: 18px;
  list-style: none;
}

.et-left li img {
  margin-right: 8px;
}

.et-right {
  padding-top: 100px;
  position: relative;
  text-align: right;
}

.et-right img {
  width: 555px;
}

/* Expert Team End */

/* Processing Flow Start */
.processing-flow {
  padding-top: 72px;
  text-align: center;
  height: 660px;
  /*border-bottom: 1px solid #eee;*/
}

.pf-content img {
  margin-top: 50px;
  background: #2d73b9;
}

/* Processing Flow End */

/* Text Solution Start */
.ts-wrapper {
  /*background: #fafafa;*/
  width: 100%;
}

.ts-content {
  height: 180px;
  padding-top: 52px;
}

.tstabs {
  /*border-bottom: 1px solid #eee;*/
}

.text-solution .title-en {
  /*font-weight: bold;*/
  font-size: 16px;
  line-height: 19px;
  color: #999999;
  margin-bottom: 4px;
}

.text-solution .title-zh {
  /*font-weight: bold;*/
  font-size: 30px;
  line-height: 33px;
  color: #000000;
  margin-bottom: 16px;
}

.tx-short {
  font-size: 18px;
  line-height: 19px;
  color: #999999;
}

.tx-btngroup button:first-child {
  margin-right: 12px;
}

.tx-btngroup .primary-btn {
  border: 1px solid transparent;
  border-radius: 2px;
  color: #fff;
  background: #176de6;
  width: 120px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
}

.tx-btngroup .primary-btn:hover {
  border: 1px solid #3f90f2;
  background: #3f90f2;
}

.tx-btngroup .default-btn {
  border: 1px solid #2d73b9;
  border-radius: 2px;
  color: #2d73b9;
  background: white;
  width: 120px;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}

.tx-btngroup .default-btn:hover {
  border: 1px solid #3f90f2;
  background: #f3f7ff;
}

.tx-btngroup .ghost-btn {
  border: 1px solid #fff;
  border-radius: 2px;
  color: #fff;
  background: transparent;
  width: 120px;
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}

.tx-btngroup .ghost-btn:hover {
  border: 1px solid #fff;
  color: #176de6;
  background: #fff;
}

/*.frontier-algorithm .rg_top {*/
/*  height: 20px;*/
/*  background: #04487d;*/
/*}*/
/*.frontier-algorithm .rg_top2{*/
/*  height: 20px;*/
/*  background: #04487d;*/
/*  margin-top: 60px;*/
/*}*/
.mt-content,
.frontier-algorithm,
.rapid-calculation,
.search-engine {
  position: relative;
}

.arrow-box {
  width: 100%;
  height: 0px;
}

.arrow-wrapper {
  width: 1px;
  background: transparent;
  margin: 0px auto;
  position: relative;
}

.arrow-wrapper .path1 {
  fill: #ffffff;
}

.arrow-wrapper .path2 {
  fill: #2d73b9;
}

.arrow-wrapper .path3 {
  fill: #f8fafc;
}

.arrow-down {
  position: absolute;
  top: -2px;
  left: -19px;
  text-align: center;
  z-index: 999;
}

/* Tab Start */
.ts-tab {
  height: 50px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  /*background: #fdfdfd;*/
  background: #2d73b9;
}

.tab-fixed {
  position: fixed !important;
  top: 0px;
  width: 100%;
  background: #fff;
  z-index: 999;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.tabpane {
  font-size: 18px;
  line-height: 50px;
  color: #666666;
  text-align: center;
}

.pane {
  height: 48px;
  color: white;
  display: inline-block;
  border-bottom: 2px solid transparent;
  cursor: default;
}

.tab-active {
  color: #000;
  border-bottom: 2px solid #4184f3;
}

/* Massive Text Data Start */
.massive-textdata {
  height: 720px;
  background: url(/img/login/bg-mt.png);
  background-size: cover;
  background-position: right;
}

.mt-left {
  padding-top: 72px;
  padding-left: 4%;
}

.mt-right {
  padding-left: 200px;
  padding-top: 178px;
}

.mt-right ul {
  margin-top: 24px;
  margin-bottom: 75px;
}

.mt-right li {
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0.04em;
  color: #999999;
}

.mt-right img {
  margin-right: 8px;
  width: 6px;
}

/* Frontier Algorithm Start */
.frontier-algorithm {
  height: 670px;
  /*background: url("/img/login/bg-fa.png");*/
  background: #2d73b9;
  background-size: cover;
}

.fa-left {
  padding-top: 205px;
  padding-left: 8%;
}

.fa-left .title-zh {
  color: #fff;
}

.fa-left .tx-btngroup {
  margin-top: 48px;
}

.fa-right {
  padding-top: 60px;
}

.fa-right img {
  position: relative;
  left: -78px;
}

/* Rapid Calculation Start */
.rapid-calculation {
  height: 720px;
  text-align: center;
  background: #f8fafc;
  position: relative;
  border-bottom: 1px solid #e7f1f6;
}

.bg-rcr {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-right: -120px;
}

.rc-content {
  padding-top: 150px;
  position: relative;
}

.bg-rcl {
  position: absolute;
  top: 0px;
  left: 0px;
}

.rc-content ul {
  margin-top: 40px;
  width: 500px;
  margin: 40px auto;
}

.rc-content li {
  margin-bottom: 26px;
  position: relative;
}

.rc-content li img {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 80px;
}

.li-r {
  margin-left: 80px;
  padding-left: 30px;
  width: 430px;
  height: 80px;
  display: inline-block;
  position: relative;
  text-align: left;
  background: #fff;
}

.li-r-title {
  position: absolute;
  left: 24px;
  top: 14px;
  font-size: 18px;
  line-height: 21px;
  color: #333333;
}

.li-r-info {
  position: absolute;
  left: 24px;
  bottom: 16px;
  font-size: 15px;
  line-height: 17px;
  color: #666666;
}

.rc-content .tx-btngroup {
  margin-top: 62px;
}

/* Search Engine Start */
.search-engine {
  height: 720px;
  background: url(/img/login/bg-se.png);
  background-size: cover;
  border-bottom: 1px solid #f8f8f8;
}

.se-left {
  padding-top: 240px;
  padding-left: 8%;
}

.se-left .tx-btngroup {
  margin-top: 48px;
}

.se-right {
  padding: 0px;
  padding-top: 108px;
}

.se-right img {
  width: 108%;
  position: relative;
  left: -8%;
}

/* Text Solution End */

/* FooterTop Start */
.footer-top {
  height: 450px;
  padding-top: 125px;
  background: #fff;
}

.ft-content {
  text-align: center;
}

.ft-content h2 {
  font-size: 32px;
  line-height: 44px;
  color: #000;
  padding: 0px;
}

.ft-content p {
  margin-top: 24px;
  font-size: 18px;
  line-height: 25px;
  text-align: center;
  color: #666666;
}

.ft-content button {
  margin-top: 45px;
}

/* FooterTop End */

/* FooterBottom Start */
.footer-bottom {
  min-height: 480px;
  background: #0b0d17;
  position: relative;
  /*padding-top: 100px;*/
}

.footer-bottom .rg_bottom {
  height: 30px;
  background: #0b0d17;
  margin-bottom: 140px;
}

.footer-bottom .rg_bottom2 {
  height: 30px;
  background: #04487d;
  margin-top: 133px;
}

.fb-logo {
  height: 55px;
}

.fb-copyright {
  margin-top: 40px;
  font-size: 14px;
  line-height: 24px;
  color: #d9dbe1;
}

.fb-copyright {
  font-size: 14px;
  line-height: 24px;
  color: #d9dbe1;
  width: 220px;
}

.fb-title {
  margin-bottom: 24px;
  color: #fff;
  font-size: 24px;
  line-height: 30px;
}

.fb-li {
  font-size: 16px;
  line-height: 24px;
  list-style: none;
  color: #d9dbe1;
  margin-bottom: 12px;
}

.fb-li:hover {
  color: #fff;
}

.fb-li a {
  font-size: 16px;
  line-height: 24px;
  list-style: none;
  color: #d9dbe1;
  margin-bottom: 12px;
}

.fb-li a:hover {
  color: #fff;
}

.fb-li .li-en {
  width: 72px;
  display: inline-block;
}

.fb-li img {
  width: 20px;
  margin-right: 8px;
}

.fb-icon {
  margin-right: 8px;
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #5f5f5f;
}

.fb-detail {
  display: inline-block;
  width: 210px;
  cursor: default;
}

.fb-mark {
  position: absolute;
  right: 0;
  top: 0;
}

/* FooterBottom End */
.beian {
  color: #d9dbe1 !important;
  font-size: 16px;
}

.beian:hover {
  color: #2d8cf0 !important;
}
</style>

<script>
import axios from "axios";
import { mapActions, mapMutations } from "vuex";

let timer;
export default {
  name: "login",
  data() {
    return {
      showAccount: true,
      showPhone: false,

      phoneNumber: "",
      verificationCode: "",
      countdown: 0,
      sending: false,
      timer: null,

      //正式账户降级为高级使用
      dialogVisible: false,
      activateModal: false,
      activateModalMessage: "",
      checked: false,
      modal11: false,
      showbtn: true, //展示获取验证码或倒计时按钮判断
      time: 120,
      btnTitle: "验证码", //input框中的文字
      username: "",
      password: "",
      params: {
        TextName: "公司公告",
      },
      PostData: {
        UserName: "",
        DbName: "",
        mokuai: "",
        caozuo: "",
        keyWords: "",
        // identity: '',
      },
      cityList: [
        {
          value: "teacher",
          label: "老师",
        },
        {
          value: "student",
          label: "学生",
        },
        {
          value: "IndustryPeople",
          label: "业界人员",
        },
      ],
      msgname: "",
      cip: "",
    };
  },
  beforeCreate() {
    //这是我们遇到的第一个生命周期函数，表示实例完全被创建出来之前，会执行它
  },

  created() {
    const urlabout = this.getUrlKey("about", window.location.href);
    if (urlabout) {
      this.modal11 = true;
    }
    const urltoken = this.getUrlKey("token", window.location.href);
    if (urltoken) {
      console.log(urltoken);
      $.ajax({
        type: "GET",
        url: "/api/tokenstate",
        beforeSend: function (request) {
          request.setRequestHeader("token", urltoken);
        },
      }).then((result) => {
        console.log(result.msg);
        if (result.msg === "登录成功") {
          //debugger

          this.SET_USER_LOGIN_INFO(result.data);

          if (this.checked === true) {
            $.cookie("username", this.username, { expires: 30 });
            $.cookie("password", this.password, { expires: 30 });
          }
          //成功后跳转首页
          this.$router.push({ path: window.location.pathname });
          // alert('')
          //插入日志
          this.PostData.UserName = this.username;
          // this.PostData.name = this.formItem.name
          this.PostData.caozuo = "登录";
          axios
            .post("/api/register/addLog", this.PostData)
            .then((res) => {})
            .catch(() => {
              // this.$Message.error('注册失败，请重试');
              return;
            });
        } else {
          this.$Message.info(result.msg);
        }
      });
    }
    const urlKey = this.getUrlKey("id", window.location.href);
    if (urlKey) {
      this.activateUser(urlKey);
    }
  },
  mounted: function () {
    this.ready();
    this.submitForm();
    $("#MsgBoardIframe").on("load", (e) => {
      $("#closeContactUsModalBtn").click();
      this.clearBgBlur();
      var responseTetx = $(e.currentTarget)[0].contentDocument.body.textContent;
      var responseJsonObj = JSON.parse(responseTetx);
      var zuiMassage;
      if (responseJsonObj.status == true) {
        this.$Message.info("您的信息已成功提交！");
      } else {
        this.$Message.info("提交失败，请重试!");
      }
    });
    if ($.cookie("username") !== "") {
      this.username = $.cookie("username");
      this.password = $.cookie("password");
    }
    /* 词云 */
    var settings = {
      entries: [
        {
          label: "财务报告",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "管理层讨论与分析",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "社会责任报告",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "IPO申报稿",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股东大会",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "董事会",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "独立董事意见",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "业绩预告",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "业绩快报",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "收购兼并",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "违规违纪",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "澄清公告",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "交易异动",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股份增持",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股份减持",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "利润分配",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股权激励",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "资产重组",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "资金投向",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "关联交易",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "担保事项",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "抵押借款",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "高管变动",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "停牌公告",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "招股说明书",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "增发预案",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股权变动",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "质押冻结",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股权分置改革",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "法律纠纷",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "公司新闻",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "行业新闻",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "宏观经济新闻",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "财经新闻",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "股市新闻",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "股吧评论",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "公司研报",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "晨会报告",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "宏观策略",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "行业研报",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "债券研究",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "期货研究",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "公司监管问询",
          color: "#4184f3",
          fontSize: 32,
        },
        {
          label: "公司业绩说明会",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "投资者问答",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "IPO路演",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "关键审计事项",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "专利文本",
          color: "#4184f3",
          fontSize: 32,
        },
        // {
        //   "label": "公司裁判文书",
        //   "color": "#4184f3",
        //   "fontSize": 32
        // },
        {
          label: "券商年报",
          color: "#4184f3",
          fontSize: 20,
        },
        {
          label: "银行年报",
          color: "#4184f3",
          fontSize: 20,
        },
      ],
      width: 600,
      height: 540,
      radius: "50%",
      radiusMin: 190,
      bgDraw: false,
      bgColor: "transparent",
      opacityOver: 1,
      opacityOut: 0.2,
      opacitySpeed: 5,
      fov: 280,
      speed: 0.07,
      fontFamily:
        "Anyway Type','Myriad Pro','PingFang SC','Microsoft YaHei',Arial,sans-serif",
      fontSize: "26",
      fontColor: "#666",
      fontWeight: "normal",
      fontStyle: "normal",
      fontStretch: "condensed",
      fontToUpperCase: false,
    };
    $("#holder").svg3DTagCloud(settings);

    if ("https://aitexts.com/clientRegist" === window.location.href) {
      this.Register();
    }
    if (window.location.href.indexOf("?contact=1") > -1) {
      $("#contactusbtn").click();
    }
    if (window.location.href.indexOf("?about=1") > -1) {
      $("#aboutusbtn").click();
    }
    if (window.location.href.indexOf("?resetpwd=1") > -1) {
      this.viewforget();
    }
  },
  methods: {
    TabQiehuanAccount() {
      this.showAccount = true;
      this.showPhone = false;
    },
    TabQiehuanPhone() {
      this.showAccount = false;
      this.showPhone = true;
    },
    validatePhoneNumberLogin(str) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      return reg.test(str);
    },
    sendVerificationCode() {
      if (!this.phoneNumber) {
        // 提示用户输入手机号或账号
        this.$Message.error("请输入手机号");
        return;
      }
      if (!this.validatePhoneNumberLogin(this.phoneNumber)) {
        this.$Message.error("请输入正确的手机号");
        return;
      }

      if (this.countdown > 0 || this.sending) return;
      this.sending = true;

      const params = {
        phone: this.phoneNumber,
        // 其他需要的参数
      };
      // 这里调用发送验证码的API
      axios
        .post("/api/user/sendPhoneMessageByLogin", params)
        .then((result) => {
          //result.data.status
          if (result.data.status) {
            this.countdown = 60;
            this.$Message.info(result.data.msg);
            let countdownInput = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(countdownInput);
              }
            }, 1000);
          } else {
            this.$Message.info(result.data.msg);
          }
        })
        .catch((error) => {
          this.$Message.error("验证码发送失败，请稍后重试");
          console.error("发送验证码失败:", error);
        })
        .finally(() => {
          this.sending = false;
        });

      // 模拟API请求
      // setTimeout(() => {
      //   this.sending = false;
      //   this.countdown = 60;
      //   this.timer = setInterval(() => {
      //     this.countdown--;
      //     if (this.countdown <= 0) {
      //       clearInterval(this.timer);
      //     }
      //   }, 1000);
      //   // 提示验证码已发送
      // }, 1000);
    },

    //忘记密码
    viewforget() {
      this.$store.commit("setRegisterFlag", {
        flag: false,
        flag2: true,
      });
    },
    playVideo() {
      console.log(1);
      this.dialogVisible = true;
    },
    // 激活用户待审核
    activateUser(val) {
      let formData = new FormData();
      formData.append("id", val);
      axios({
        method: "post",
        url: "/api/register/activateUserStatus",
        data: formData,
        headers: { "content-type": "multipart/form-data" },
      })
        .then((res) => {
          if (res.data.status) {
            this.activateModalMessage = res.data.msg;
            this.activateModal = true;
          } else {
            this.activateModalMessage = res.data.msg;
            this.activateModal = true;
          }
          this.$router.replace("/");
        })
        .catch((err) => {
          this.$Message.info("激活失败,请联系管理员!");
          this.$router.replace("/");
          console.error(err);
        });
    },

    // 获取url中的参数
    getUrlKey(name, url) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            url
          ) || [undefined, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    async ready() {
      try {
        let cip = await axios.get("/api/getip?" + new Date().getTime());
        this.cip = cip.data;
      } catch (e) {}
    },
    ...mapMutations(["SET_USER_LOGIN_INFO"]),
    ...mapActions(["login"]),
    async handleButtonSubmit() {
      if (this.showPhone == true && this.showAccount == false) {
        //手机号登录
        if (this.phoneNumber === "" || this.verificationCode === "") {
          this.$Message.info("请输入手机号及验证码！");
          return;
        }

        let result = await this.login({
          UserName: this.phoneNumber,
          Password: this.verificationCode,
          type: "byPhoneLogin",
        });
        if (result.data.status === true) {
          if (result.data.msg === "账号到期已降为高级使用账号") {
            this.$Message.info(
              "尊敬的用户您好，您的账户已经到期将降为高级试用，请尽快续期以避免影响您的使用！"
            );
          }
          //debugger
          this.SET_USER_LOGIN_INFO(result.data.data);
          //成功后跳转首页
          this.$router.push({ path: "/index" });
          // alert('')
          //插入日志
          this.PostData.UserName = this.username;
          // this.PostData.name = this.formItem.name
          this.PostData.caozuo = "登录";
          axios
            .post("/api/register/addLog", this.PostData)
            .then((res) => {})
            .catch(() => {
              return;
            });
        } else {
          $("#login_warning_phone").text(result.data.msg);
        }
      } else {
        if (this.username === "" || this.password === "") {
          this.$Message.info("请输入用户名及密码！");
          return;
        }

        let result = await this.login({
          UserName: this.username,
          Password: this.password,
          type: "byPasswordLogin",
        });
        if (result.data.status === true) {
          if (result.data.msg === "账号到期已降为高级使用账号") {
            this.$Message.info(
              "尊敬的用户您好，您的账户已经到期将降为高级试用，请尽快续期以避免影响您的使用！"
            );
          }
          //debugger
          this.SET_USER_LOGIN_INFO(result.data.data);
          if (this.checked === true) {
            $.cookie("username", this.username, { expires: 30 });
            $.cookie("password", this.password, { expires: 30 });
          }
          //成功后跳转首页
          this.$router.push({ path: "/index" });
          // alert('')
          //插入日志
          this.PostData.UserName = this.username;
          // this.PostData.name = this.formItem.name
          this.PostData.caozuo = "登录";
          axios
            .post("/api/register/addLog", this.PostData)
            .then((res) => {})
            .catch(() => {
              return;
            });
        } else {
          $("#login_warning").text(result.data.msg);
        }
      }

      // this.login(params).then(result => {
      //
      //
      //   if (result.data.msg === "登录成功" || result.data.msg === "账号到期已降为高级使用账号") {
      //
      //     if(result.data.msg === "账号到期已降为高级使用账号"){
      //       this.$Message.info('This is a info tip');
      //     }
      //
      //     //debugger
      //     this.SET_USER_LOGIN_INFO(result.data.data);
      //     if (this.checked === true) {
      //       $.cookie("username", this.username, {expires: 30});
      //       $.cookie("password", this.password, {expires: 30});
      //     }
      //     //成功后跳转首页
      //     this.$router.push({path: '/index'})
      //     // alert('')
      //     //插入日志
      //     this.PostData.UserName = this.username
      //     // this.PostData.name = this.formItem.name
      //     this.PostData.caozuo = '登录'
      //     axios.post('/api/register/addLog', this.PostData)
      //         .then((res) => {
      //
      //         }).catch(() => {
      //       // this.$Message.error('注册失败，请重试');
      //       return
      //     })
      //     // this.PostData.identity = this.formItem.identity
      //     //console.log(this.formItem)
      //     //console.log(this.PostData.identity)
      //
      //
      //   } else {
      //     $("#login_warning").text(result.data.msg);
      //   }
      // });
    },
    Register() {
      this.$store.commit("setRegisterFlag", {
        flag: true,
        flag2: false,
      });
    },
    // Register02() {
    //   window.open(
    //     "https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitextclient%2F%E7%88%B1%E6%96%87%E6%9C%AC%E5%AE%A2%E6%88%B7%E7%AB%AF1.0.81Setup.exe"
    //   );
    //   this.modalDownload = false;
    // },
    bgToBlur: function () {
      $(".bodyDiv").css("-webkit-filter", "blur(7px)");
      $("#number-container").css("-webkit-filter", "blur(7px)");
    },
    clearBgBlur: function () {
      $(".bodyDiv").css("-webkit-filter", "blur(0px)");
      $("#number-container").css("-webkit-filter", "blur(0px)");
    },
    navToapper: function () {
      $(".navbar").css("display", "block");
    },
    navToDisplay: function () {
      $(".navbar").css("display", "none");
    },

    clearWarning: function () {
      $("#login_warning").text("");
    },
    gosection1() {
      // document.querySelector(".processing-flow").scrollIntoView({
      //   behavior: "smooth"
      // });

      // window.open(
      //   "https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitextclient%2F%E7%88%B1%E6%96%87%E6%9C%AC%E5%AE%A2%E6%88%B7%E7%AB%AF1.0.81Setup.exe"
      // );
      // this.modalDownload = false;

      axios
        .get("/api/register/getDownloadAitextClient")
        .then((res) => {
          if (res.status === 200) {
            // console.log(res.data);
            window.open(res.data.data);
          }
        })
        .catch((e) => {
          console.warn(e);
        });
    },
    gotop() {
      document.querySelector(".login_bg").scrollIntoView({
        behavior: "smooth",
      });
    },
    schoolLogin() {
      this.$Message.info("功能未开放");
    },
    submitForm: function () {
      var vaildatorRule = {
        message: "This value is not valid",
        feedbackIcons: {
          valid: "glyphicon glyphicon-ok",
          invalid: "glyphicon glyphicon-remove",
          validating: "glyphicon glyphicon-refresh",
        },
        fields: {
          name: {
            message: "The username is not valid",
            validators: {
              notEmpty: {
                message: "请输入您的称呼",
              },
            },
          },
          email: {
            validators: {
              notEmpty: {
                message: "请输入您的email地址",
              },
              emailAddress: {
                message: "不符合email地址规则",
              },
            },
          },
          school: {
            validators: {
              notEmpty: {
                message: "请输入您的学校",
              },
            },
          },
          phone: {
            validators: {
              notEmpty: {
                message: "请输入您的联系电话",
              },
              stringLength: {
                max: 11,
                message: "电话长度必须为11位",
              },
              regexp: {
                regexp: /^1(3|4|5|6|7|8|9)\d{9}$/,
                message: "电话格式不正确，如：【17821816737】",
              },
            },
          },
          message: {
            validators: {
              notEmpty: {
                message: "请输入您的留言信息",
              },
            },
          },
        },
      };
      $("#submitAdviceForm").bootstrapValidator(vaildatorRule);
    },
  },
};
</script>
